var _0xb469=["\x4E\x6F\x50\x61\x64\x64\x69\x6E\x67","\x70\x61\x64"];CryptoJS[_0xb469[1]][_0xb469[0]]={pad:function(){},unpad:function(){}};